import { frontendURL } from "../../../../helper/URLHelper";
import PlatformActivityIndex from "./Index.vue";
import SettingsWrapper from "../SettingsWrapper.vue";

export default {
  routes: [
    {
      path: frontendURL("accounts/:accountId/settings/platform-activity"),
      component: SettingsWrapper,
      children: [
        {
          path: "",
          name: "settings_platform_activity",
          component: PlatformActivityIndex,
          meta: {
            permissions: ["administrator"],
          },
        },
      ],
    },
  ],
};